import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Button,
  Container,
  Col,
  Row,
  CardFooter,
  Stack,
  Form,
  Badge,
} from "react-bootstrap";
import "../../layouts/Flipcard.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoanDetailsModal from "../../components/LoanDetailsModal";
import { MODULEDUES } from "../../services/actions";
import GoldPaymentConfirmationModal from "../../components/GoldPaymentConfirmationModal";

const Flipcard = ({
  onMoreClick,
  loanTypeDesc,
  Acc_number,
  Disb_amt,
  Due_amt,
  StartDate,
  MaturityDate,
  Instmnt,
  onPay,
  Loan,
  pledgeNetWeight,
  RD_redemptionDate,
  moduleCode,
  RD_installmentAmount,
  RD_depositType,
  interestAmountDue,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  // const [dueAmount, setDueAmount] = useState(Due_amt); // State to manage due amount
  const [dueAmount, setDueAmount] = useState(
    moduleCode === "RD" ? RD_installmentAmount : Due_amt
  );

  // due details data api for modals
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [showGoldConfirmModal, setShowGoldConfirmModal] = useState(false);
  const [showDuesDetails, setshowDuesDetails] = useState(false);
  const moduleduesState = useSelector((state) => state.moduleduesState?.data);

  const [isInvalid, setIsInvalid] = useState(false);
  const [isMinInvalid, setIsMinInvalid] = useState(false);
  const cardRef = useRef(null); // Reference to the card element

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  // Reset the card flip after 10 seconds
  useEffect(() => {
    let timer;
    if (isFlipped) {
      timer = setTimeout(() => {
        setIsFlipped(false);
      }, 20000); // 10 seconds
    }
    return () => clearTimeout(timer); // Cleanup timeout on unmount or flip state change
  }, [isFlipped]);

  // Reset dueAmount to the initial Due_amt when the card resets or flips
  useEffect(() => {
    if (!isFlipped) {
      setDueAmount(moduleCode === "RD" ? RD_installmentAmount : Due_amt);
    }
  }, [isFlipped, Due_amt, moduleCode, RD_installmentAmount]);



  const handlePayButtonClick = (event) => {
    event.stopPropagation(); // Prevent the flip when the Pay button is clicked
    dispatch({
      type: `${MODULEDUES}_POST`,
      payload: {
        uniqueAccountNumber: Acc_number,
        moduleCode: moduleCode,
      },
      callback:(res)=>{
        if(res.is_success){
          if (res?.data) {
      
            const NetAmount = res?.data?.netAmount;
      
            if (moduleCode === "GOLD" && dueAmount >= NetAmount) {
              // Show confirmation modal
              setShowGoldConfirmModal(true);
      
              console.log("Gold module found", NetAmount);
            } else {
              if (onPay) {
                onPay(dueAmount); // Pass the dueAmount to the parent component
              }
              console.log("Pay button clicked");
              console.log({ dueAmount });
              console.log({ onPay });
              navigate("/order/", {
                state: {
                  ...Loan, // Spread the loan object and pass it as state
                  dueAmount, // Optionally, you can include the modified dueAmount here
                },
              });
            }
          }

        }
        
      }
    });
    // fetchLoanDetails(Acc_number,moduleCode)
    // const NetAmount=moduleduesState?.data?.netAmount

    // if (moduleCode === "GOLD" && dueAmount>= NetAmount) {
    //   // Show confirmation modal
    //   setShowGoldConfirmModal(true);

    //    console.log("Gold module found",NetAmount)

    //   } else {
    // if (onPay) {
    //   onPay(dueAmount); // Pass the dueAmount to the parent component
    // }
    // console.log("Pay button clicked");
    // console.log({ dueAmount });
    // console.log({ onPay });

    // navigate("/order/", {
    //   state: {
    //     ...Loan, // Spread the loan object and pass it as state
    //     dueAmount, // Optionally, you can include the modified dueAmount here
    //   },
    //   // });
    // }
  };
  // const handleInputChange = (event) => {
  //   event.stopPropagation();
  //   setDueAmount(event.target.value); // Update state on input change
  // };
  const handleOutsideClick = (event) => {
    if (cardRef.current && !cardRef.current.contains(event.target)) {
      setIsFlipped(false); // Flip the card back to its initial state
    }
  };
  const handleInputChange = (event) => {
    event.stopPropagation();

    const value = event.target.value.replace(/^0+|[^0-9]/g, ""); // Clean input
    const numericValue = value ? parseInt(value, 10) : "";

    if (numericValue !== "" && numericValue < 1) {
      setIsMinInvalid(true);
      setIsInvalid(false); // Don't check RD rule if min itself fails
    } else {
      setIsMinInvalid(false);

      if (moduleCode === "RD" && numericValue !== "") {
        const isNotMultiple = numericValue % RD_installmentAmount !== 0;
        setIsInvalid(isNotMultiple);
      } else {
        setIsInvalid(false);
      }
    }

    setDueAmount(value);
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center vh-10">
      <div
        ref={cardRef}
        className={`credit-card ${isFlipped ? "flipped" : ""}`}
        onClick={handleFlip}
      >
        {/* Front of the card */}

        <div className="card-front">
          <Stack
            direction="horizontal "
            className="position-absolute top-0 end-0 m-2"
            gap={2}
          >
            <Badge bg="info">Tap to pay</Badge>
          </Stack>
          <Stack>
            {/* modal button "More Details*/}
            {/* ****************************** */}
            {/* <Button
              size="sm"
              variant="light"
              style={{
                position: "absolute",
                bottom: "5px",
                right: "5px",
                fontSize: "12px",
              }}
              onClick={(e) => {
                e.stopPropagation(); // Prevent card flip
                onMoreClick();
              }}
            >
              More
            </Button> */}
          </Stack>
          <span>
            {loanTypeDesc && (
              <div className="card-brand mt-2">{loanTypeDesc}</div>
            )}
            {RD_depositType && (
              <div className="card-brand mt-2">
                {moduleCode} <span></span>
                {RD_depositType}
              </div>
            )}
            <div className="card-text">
              <span className="spaced-text">A/c No:</span>
              {Acc_number}
            </div>{" "}
            <div className="card-strip"></div>
            {Disb_amt !== null && Disb_amt !== undefined && Disb_amt !== 0 && (
              <div className="card-text">
                <span>Amount&nbsp;:&nbsp;</span>₹{Disb_amt}
              </div>
            )}
            {Due_amt && Due_amt !== 0 && (
              <div className="card-text-bold">
                <span>Due Amount : </span>₹{Due_amt}
              </div>
            )}
            {RD_installmentAmount && (
              <div className="card-text-bold">
                <span>Installement : </span>₹{RD_installmentAmount}
              </div>
            )}
            {Instmnt && (
              <div className="card-text-bold">
                <span>Total Installement : </span>
                {Instmnt}
              </div>
            )}
            {interestAmountDue && interestAmountDue !== 0 && (
              <div className="card-text">
                <span>Interest Amt. Due&nbsp;:&nbsp;</span>₹{interestAmountDue}
              </div>
            )}
            <div className="card-text">
              <span>Open Date (MM/DD/YYYY)&nbsp;:&nbsp;</span>
              {StartDate}
            </div>
            {pledgeNetWeight && (
              <div className="card-text">
                <span>Pledge Net Weight&nbsp;:&nbsp;</span>
                {pledgeNetWeight}
                <span>&nbsp;grams&nbsp;</span>
              </div>
            )}
          </span>
        </div>

        {/* Back of the card */}
        <div className="card-back">
          <div
            className="card-back-title"
            // style={{ borderBottom: "1px solid gray", paddingBottom: "2px" }}
          >
            Make Payment
          </div>
          {loanTypeDesc && (
            <div className="card-brand mt-2">{loanTypeDesc}</div>
          )}
          {RD_depositType && (
            <div className="card-brand mt-2">
              {moduleCode} <span></span>
              {RD_depositType}
            </div>
          )}

          <div className="card-text">
            <span className="spaced-text">A/c No:</span>
            {Acc_number}
          </div>
          <div className="card-strip"></div>
          <div className="mx-2">
            {/* <div className="card-back-accno">{Acc_number}</div> */}

            {Disb_amt !== null && Disb_amt !== undefined && Disb_amt !== 0 && (
              <div className="card-text">
                <span>Amount&nbsp;:&nbsp;</span>₹{Disb_amt}
              </div>
            )}
            {Due_amt && (
              <div className="card-text-bold">
                <span>Total Due Amount : </span>₹{Due_amt}
              </div>
            )}
          </div>
          {/* Input box with default value */}

          <Stack direction="horizontal" gap={3}>
            <label
              htmlFor="due-amount"
              style={{ marginLeft: "1px", fontSize: "12px" }}
            >
              Amount:
            </label>
            <input
              id="due-amount"
              type="text"
              min="1"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/^0+|[^0-9]/g, ""); // Clean input
              }}
              onClick={handleInputChange}
              onChange={handleInputChange}
              value={dueAmount}
              className={`form-control ${
                isInvalid || isMinInvalid ? "is-invalid" : ""
              }`}
              style={{
                width: "100%",
                fontSize: "12px",
                display: "inline-block",
                margin: "1px",
              }}
            />
            <Button
              variant="success px-4"
              size="small"
              onClick={handlePayButtonClick}
              disabled={isInvalid || isMinInvalid}
              hh
            >
              Pay
            </Button>
            <div />
          </Stack>
          {isInvalid && !isMinInvalid && (
            <div style={{ color: "red", fontSize: "11px", marginTop: "4px" }}>
              Amount must be a multiple of Installement Amt ₹
              {RD_installmentAmount}
            </div>
          )}
          {isMinInvalid && (
            <div style={{ color: "red", fontSize: "11px", marginTop: "4px" }}>
              Minimum amount of ₹1 required
            </div>
          )}

          {/* <div className="card-back-accno" style={{ width: "100%", boxSizing: "border-box", padding: "10px" }}>
            <label htmlFor="due-amount" style={{ marginLeft:"10px"}}>Due Amount:</label>
            <input
              id="due-amount"
              type="text"
              onClick={handleInputChange}
              onChange={handleInputChange}
              value={dueAmount}
              className="form-control"
              style={{ width: "100%",fontSize:"15px", display: "inline-block", margin:"1px"}}
            />
            <Button className="mr-auto app-btn-primary"  
            style={{ width: '100%',paddingTop:"5px",marginTop :"5px", overflow: "hidden",marginBottom: "5px"}}onClick={handlePayButtonClick} >Pay</Button>
          </div> */}
        </div>
      </div>
      <GoldPaymentConfirmationModal
        show={showGoldConfirmModal}
        onHide={() => setShowGoldConfirmModal(false)}
        onConfirm={() => {
          setShowGoldConfirmModal(false);
          navigate("/order/", {
            state: {
              ...Loan,
              dueAmount,
            },
          });
          // proceedToPay();
        }}
        amount={dueAmount}
      />
    </div>
  );
};

export default Flipcard;
